export default {
  nav: {
    home: 'Ana Sayfa',
    categories: 'Kategoriler',
    cart: 'Sepet',
    orders: 'Siparişler',
    wishlist: 'Favoriler',
    vendor: 'Satıcı',
    notifications: 'Bildirimler',
    profile: 'Profil',
    addresses: 'Adresler',
    paymentMethods: 'Ödeme Yöntemleri',
    security: 'Güvenlik',
    settings: 'Ayarlar',
    storyEditor: 'Story Editör',
    more: 'Daha Fazla',
    closeMenu: 'Menüyü Kapat',
    language: 'Dil',
    help: 'Yardım ve Destek',
  },
  header: {
    welcome: 'Hoş Geldiniz',
    searchPlaceholder: 'Ürün, marka ve kategori ara...',
    searchMobile: 'Ara...',
    search: 'Ara',
    delivery: 'Teslimat',
    pickup: 'Gel-Al',
    selectAddress: 'Adres Seç',
    selectLocation: 'Konum Seç',
    schedule: 'Zamanlama',
    setAddress: 'Adres Ayarla',
    inStorePickup: 'Mağazadan Teslim',
    notifications: 'Bildirimler',
    customer: 'Müşteri',
    guest: 'Misafir',
    address: 'Adres',
    scheduledSelected: 'Zamanlı teslimat seçildi',
    courierSelected: 'Kurye teslimatı seçildi',
    pickupSelected: 'Mağazadan teslim seçildi',
    searchingFor: 'Arıyorum',
  },
  common: {
    save: 'Kaydet',
    cancel: 'İptal',
    edit: 'Düzenle',
    delete: 'Sil',
    add: 'Ekle',
    confirm: 'Onayla',
    back: 'Geri',
    backToProfile: 'Profile Dön',
    next: 'İleri',
    close: 'Kapat',
    loading: 'Yükleniyor...',
    error: 'Hata',
    success: 'Başarılı',
    empty: 'Boş',
    seeAll: 'Tümünü Gör',
    appName: 'Bazaarak',
    appNameEn: 'Bazaarak',
    currency: 'TRY',
    viewAll: 'Tümünü Gör',
    items: 'ürün',
    store: 'Mağaza',
    clear: 'Temizle',
    enabled: 'Etkin',
    disabled: 'Devre dışı',
    enable: 'Etkinleştir',
  },
  auth: {
    login: 'Giriş Yap',
    register: 'Kaydol',
    logout: 'Çıkış Yap',
    email: 'E-posta',
    password: 'Şifre',
    phone: 'Telefon',
    forgotPassword: 'Şifremi Unuttum',
    signInRequired: 'Giriş Gerekli',
    addressSignInPrompt: 'Teslimat adreslerinizi yönetmek için lütfen giriş yapın',
    unauthorized: 'Oturum süresi doldu. Lütfen tekrar giriş yapın.',
    signIn: 'Giriş Yap',
    signUp: 'Kaydol',
    createAccount: 'Hesap Oluştur',
    welcomeBack: 'Tekrar Hoş Geldiniz!',
    createYourAccount: 'Hesabınızı Oluşturun',
    customer: 'Müşteri',
    vendor: 'Satıcı',
    name: 'İsim',
    fullName: 'Tam Ad',
    storeName: 'Mağaza Adı',
    confirmPassword: 'Şifreyi Onayla',
    enterYourName: 'Adınızı girin',
    emailOrUsername: 'E-posta / Kullanıcı Adı',
    enterEmailOrUsername: 'E-posta veya kullanıcı adınızı girin',
    enterYourPassword: 'Şifrenizi girin',
    confirmYourPassword: 'Şifrenizi onaylayın',
    enterStoreName: 'Mağaza adını girin',
    enterPhoneNumber: '+90 532 123 45 67',
    rememberMe: 'Beni Hatırla',
    orContinueWith: 'Veya devam et',
    continueWithGoogle: "Google ile Devam Et",
    continueWithApple: "Apple ile Devam Et",
    noAccount: 'Hesabınız yok mu?',
    hasAccount: 'Zaten hesabınız var mı?',
    backToHome: 'Ana Sayfaya Dön',
    signingIn: 'Giriş yapılıyor...',
    creatingAccount: 'Hesap oluşturuluyor...',
    verifiedVendor: 'Onaylı Satıcı',
  },
  product: {
    addToCart: 'Sepete Ekle',
    addToWishlist: 'Favorilere Ekle',
    buyNow: 'Hemen Al',
    outOfStock: 'Stokta Yok',
    discount: 'İndirim',
    price: 'Fiyat',
    originalPrice: 'Orijinal Fiyat',
    reviews: 'değerlendirme',
    description: 'Açıklama',
    related: 'Benzer Ürünler',
    inStock: 'stokta',
    quantity: 'Miktar',
    availability: 'Stok Durumu',
    selectVariant: 'Varyant Seç',
    save: 'Tasarruf',
    notFound: 'Ürün Bulunamadı',
    notFoundDesc: 'Bu ürün mevcut değil veya kaldırılmış.',
    browseProducts: 'Ürünlere Göz At',
    home: 'Ana Sayfa',
    addingToCart: 'Ekleniyor...',
    addingToWishlist: 'Ekleniyor...',
    addedToCart: 'sepete eklendi!',
    addedToWishlist: 'Favorilere eklendi!',
    failedToLoad: 'Ürün yüklenemedi',
    failedToAddCart: 'Sepete eklenemedi',
    failedToAddWishlist: 'Favorilere eklenemedi',
    viewCart: 'Sepeti Gör',
    products: 'ürünler',
    nSellers: '{{count}} satıcı',
    fromPrice: 'dan',
    priceRange: '€{{from}} ile €{{to}} arasında',
    chooseStore: 'Mağaza seçin',
    soldBySelected: 'Seçili mağaza tarafından satılır',
    availableAtStores: 'Birkaç mağazada mevcut: {{count}}',
    store: 'Mağaza',
    multipleVariants: '{{count}} seçenek',
  },
  cart: {
    title: 'Alışveriş Sepeti',
    empty: 'Sepetiniz boş',
    emptyDesc: 'Sepete ürün eklemek için alışveriş yapın',
    total: 'Toplam',
    checkout: 'Ödemeye Geç',
    continueShopping: 'Alışverişe Devam Et',
    orderSummary: 'Sipariş Özeti',
    subtotal: 'Ara Toplam',
    shipping: 'Kargo',
    tax: 'Vergi (%19)',
    discount: 'İndirim',
    couponCode: 'Kupon Kodu',
    enterCode: 'Kod girin',
    apply: 'Uygula',
    couponApplied: 'Kupon uygulandı (%10 indirim)',
    free: 'ÜCRETSİZ',
    processing: 'İşleniyor...',
    secureCheckout: 'Stripe ile güvenli ödeme',
    signIn: 'Lütfen Giriş Yapın',
    signInDesc: 'Sepeti görmek için giriş yapın',
    itemsInCart: 'sepette ürün',
    each: 'adet',
  },
  categories: {
    browse: 'Kategorilere Göz At',
    explore: 'Tüm kategorilerdeki geniş koleksiyonumuzu keşfedin',
    all: 'Tüm Kategoriler',
    electronics: 'Elektronik',
    fashion: 'Moda & Giyim',
    home: 'Ev & Bahçe',
    sports: 'Spor & Outdoor',
    books: 'Kitap & Medya',
    beauty: 'Güzellik & Sağlık',
    toys: 'Oyuncak & Oyunlar',
    automotive: 'Otomotiv',
    jewelry: 'Takı & Saat',
    pet: 'Evcil Hayvan',
    office: 'Ofis Malzemeleri',
    productsAvailable: 'ürün mevcut',
    subcategories: 'Alt Kategoriler',
    noProductsFound: 'Ürün bulunamadı:',
    products: 'Ürünler',
  },
  home: {
    browseByCategory: 'Kategoriye Göre Alışveriş',
    browseCategoryDesc: 'Premium kategorilerimizin geniş yelpazesini keşfedin',
    featuredProducts: 'Öne Çıkan Ürünler',
    featuredDesc: 'Sizin için özenle seçilmiş ürünler',
    nearYouProducts: 'Şu an yakınınızda',
    nearYouDesc: 'Bölgenize ve yerel saatinize göre',
    topProducts: 'En İyi Ürünler',
    topProductsDesc: 'Bu haftanın en çok satanları',
    sold: 'satıldı',
    youMightLike: 'Beğenebilirsiniz',
    youMightLikeDesc: 'Favori mağazalarınızdan seçilmiş ürünler',
    trendingNow: 'Şu An Trend',
    trendingDesc: 'En son trendlerin önünde olun',
    premiumMarketplace: 'Premium Pazar Yeri',
    heroTitle1: 'Keşfedin',
    heroTitle2: 'Premium Ürünler',
    heroDesc: 'Premium markalar ve özel ürünlerden oluşan seçkimizle lüks alışveriş deneyimi yaşayın.',
    exploreNow: 'Şimdi Keşfet',
    becomeVendor: 'Satıcı Ol',
    products: 'Ürün',
    vendors: 'Satıcı',
    happyCustomers: 'Mutlu Müşteri',
    deliverTo: 'Teslimat',
    selectAddress: 'Adres Seçin',
    schedule: 'Zamanlama',
    selectDateTime: 'Tarih ve Saat Seçin',
    popularSearches: 'POPÜLER ARAMALAR',
    shopNow: 'Alışveriş Yap',
    explore: 'Keşfet',
    summerCollection: 'Yaz Koleksiyonu 2024',
    summerDesc: 'Bu sezonun en sıcak trendlerini keşfedin',
    smartHome: 'Akıllı Ev Essentials',
    smartHomeDesc: 'Yaşam alanınızı dönüştürün',
    wellness: 'Wellness & Bakım',
    wellnessDesc: 'Sağlığınız için premium ürünler',
    fashion: 'Moda',
    tech: 'Teknoloji',
    beauty: 'Güzellik',
    selectDeliveryAddress: 'Teslimat Adresi Seçin',
    scheduleDelivery: 'Teslimat Planla',
    addNewAddress: 'Yeni Adres Ekle',
    selectDate: 'Tarih Seçin',
    selectTimeSlot: 'Zaman Dilimi Seçin',
    confirmSchedule: 'Zamanlamayı Onayla',
    topVendors: 'En İyi Mağazalar',
    topVendorsDesc: 'Size yakın güvenilir mağazalar',
    topRatedNearYou: 'Yakınınızda en yüksek puanlı',
    discoverWhatYouLike: 'Beğendiğiniz şeyleri keşfedin',
    sponsored: 'Sponsorlu',
    filter: {
      'all': 'Tümü',
      'wishlist': 'Favoriler',
      'on-sale': 'İndirimde',
      'free-shipping': 'Ücretsiz Kargo',
      'new-arrivals': 'Yeni Gelenler',
      'best-seller': 'En Çok Satan',
      'top-rated': 'En Yüksek Puanlı',
      'price-drop': 'Fiyat Düşüşü',
      'express': 'Express',
      'premium': 'Premium',
    },
    topStores: 'En İyi Mağazalar',
    since: 'Den Beri',
  },
  orders: {
    title: 'Siparişlerim',
    totalOrders: 'toplam sipariş',
    noOrders: 'Sipariş bulunamadı',
    noOrdersDesc: 'Siparişlerinizi görmek için alışveriş yapın!',
    signIn: 'Lütfen Giriş Yapın',
    signInDesc: 'Siparişleri görmek için giriş yapın',
    all: 'Tümü',
    processing: 'İşleniyor',
    shipped: 'Kargoda',
    delivered: 'Teslim Edildi',
    cancelled: 'İptal Edildi',
    orderedOn: 'Sipariş tarihi',
    estDelivery: 'Tahmini teslimat:',
    viewDetails: 'Detayları Gör',
    hideDetails: 'Detayları Gizle',
    track: 'Takip Et',
    orderItems: 'Sipariş Ürünleri',
    priceDetails: 'Fiyat Detayları',
    shippingAddress: 'Teslimat Adresi',
    tracking: 'Takip:',
    subtotal: 'Ara Toplam',
    shipping: 'Kargo',
    tax: 'Vergi (%19)',
    total: 'Toplam',
    item: 'ürün',
    items: 'ürün',
    qty: 'Adet:',
  },
  profile: {
    title: 'Profil',
    backToHome: 'Ana Sayfaya Dön',
    editProfile: 'Profili Düzenle',
    saveChanges: 'Değişiklikleri Kaydet',
    memberSince: 'Üyelik tarihi',
    email: 'E-posta',
    phone: 'Telefon',
    address: 'Adres',
    myOrders: 'Siparişlerim',
    viewAllPurchases: 'Tüm alışverişleri gör',
    savedItems: 'kaydedilmiş ürün',
    manageLocations: 'Adresleri yönet',
    savedCards: 'Kayıtlı kartlar',
    preferences: 'Tercihler',
    passwordAnd2FA: 'Şifre & 2FA',
    language: 'Dil',
    helpSupport: '7/24 Yardım',
    logout: 'Çıkış Yap',
    confirmLogout: 'Çıkışı Onayla',
    confirmLogoutDesc: 'Hesabınızdan çıkmak istediğinizden emin misiniz?',
    uploadProfilePicture: 'Profil Fotoğrafı Yükle',
    clickToUpload: 'Yüklemek için tıklayın veya sürükleyip bırakın',
    chooseFile: 'Dosya Seç',
    version: 'BAZARAK v1.0.0',
    terms: 'Şartlar',
    privacy: 'Gizlilik',
    backToProfile: 'Profile Dön',
    welcomeBack: 'Tekrar hoş geldin, {{name}}',
    yourPoints: 'Puanların',
    yourLevel: 'Seviyen',
    levelBronze: 'Bronz',
    levelSilver: 'Gümüş',
    levelGold: 'Altın',
    levelDiamond: 'Elmas',
    levelLegend: 'Efsane',
    pointsToNext: 'Sonraki seviye için {{count}} puan daha gerekli',
    maxLevel: 'En yüksek seviyeye ulaştın',
    memberOfSince: '{{date}} tarihinden beri Bazaarak üyesi',
    proTitle: 'Bazaarak Pro',
    proDesc: 'Özel avantajlarla daha lüks bir deneyim',
    proUpgrade: 'Pro’ya yükselt',
    proExtend: 'Pro’yu uzat',
    proActive: 'Aktif',
    proActivated: 'Pro üyelik aktifleştirildi',
    proActiveUntil: '{{date}} tarihine kadar aktif',
    proBenefitShipping: 'Ücretsiz kargo',
    proBenefitDiscounts: 'Özel indirimler',
    proBenefitSupport: 'Öncelikli destek',
    proBenefitReturns: 'Ücretsiz iade',
    proComingSoon: 'Pro üyelik yakında',
    inviteTitle: 'Arkadaşlarını davet et',
    inviteDesc: 'Arkadaşlarını davet et, puan ve ödül kazan',
    inviteCode: 'Davet kodun',
    inviteCta: 'Davet et ve puan kazan',
    inviteCopied: 'Davet kodu kopyalandı',
    enterInviteCode: 'Davet kodu gir',
    applyInvite: 'Kodu uygula',
    referralApplied: 'Davet bonusu uygulandı',
    referralBonusHint: 'Sen ve arkadaşın her biriniz {{count}} puan kazanır',
    shareInviteText: 'Bazaarak’a katıl! Davet kodum: {{code}}',
    orderAll: 'Tüm siparişler',
    orderProcessing: 'İşleniyor',
    orderShipped: 'Kargoda',
    orderDelivered: 'Teslim edildi',
    orderReturns: 'İadeler',
    accountInfo: 'Hesap bilgileri',
    giftCards: 'Hediye kartları',
    giftCardsSoon: 'Hediye kartları yakında',
    supportHelp: 'Destek ve yardım',
    settings: 'Ayarlar',
    levelPlatinum: 'Platin',
    pullForMemberPass: 'Aşağı çek — üye festival kartı',
    pullToHidePass: 'Kapatmak için yukarı çek',
    memberPassEyebrow: 'Üye kulübü',
    memberPassTitle: 'Bazaarak — Bringing Home Closer',
    memberPassSubtitle: '{{level}} seviyen festival ayrıcalıklarını açar',
    yourQrCode: 'QR kodunuz',
    scanToInvite: 'Arkadaşların bu kodu tarayarak davetinle katılır',
    festivalPerksTitle: 'Festival avantajların',
    festivalPerkAccess: 'Festival alanına erişim',
    festivalPerkDiscount: 'Festivale özel indirimler',
    festivalPerkGift: 'Özel hediye ve paketleme',
    festivalPerkPoints: 'Festivalde çift puan',
    festivalPerkVip: 'VIP etkinlik girişi',
    festivalPerkEarly: 'İndirimlere erken erişim',
  },
  wishlist: {
    title: 'Favorilerim',
    saved: 'kaydedildi',
    totalValue: 'Toplam Değer',
    potentialSavings: 'Olası Tasarruf',
    inStock: 'Stokta',
    addToCart: 'Sepete Ekle',
    addAllToCart: 'Tümünü Sepete Ekle',
    shareWishlist: 'Favori Listesini Paylaş',
    empty: 'Favori Listeniz Boş',
    emptyDesc: 'Beğendiğiniz ürünleri favorilere ekleyin',
    startShopping: 'Alışverişe Başla',
    signIn: 'Lütfen Giriş Yapın',
    signInDesc: 'Favorileri görmek için giriş yapın',
    removedFromWishlist: 'Favorilerden kaldırıldı',
    failedToLoad: 'Favoriler yüklenemedi',
    backToProfile: 'Profile Dön',
  },
  vendor: {
    dashboard: 'Satıcı Paneli',
    manageDashboard: 'Mağazanızı yönetin ve performansı takip edin',
    editStore: 'Mağazayı Düzenle',
    addProduct: 'Ürün Ekle',
    createStory: 'Story Oluştur',
    overview: 'Genel Bakış',
    overviewTab: 'Genel Bakış',
    productsTab: 'Ürünler',
    storiesTab: 'Storiler',
    analyticsTab: 'Analitik',
    totalSales: 'Toplam Satış',
    orders: 'Siparişler',
    products: 'Ürünler',
    customers: 'Müşteriler',
    recentOrders: 'Son Siparişler',
    viewAll: 'Tümünü Gör',
    inventoryAlerts: 'Stok Uyarıları',
    manageInventory: 'Stoku Yönet',
    myStories: 'Storilerim',
    stories: 'story',
    editStoreInfo: 'Mağaza Bilgilerini Düzenle',
    addNewProduct: 'Yeni Ürün Ekle',
    editProduct: 'Ürünü Düzenle',
    createNewStory: 'Yeni Story Oluştur',
    editStory: 'Storiyi Düzenle',
    stripeAlertTitle: 'Stripe Hesabı Bağlı Değil',
    stripeAlertDesc: 'Ürün satışlarından gelir elde etmek için önce Stripe hesabınızı bağlayın. Onsuz ürün eklemeye izin verilmez.',
    stripeConnectBtn: 'Stripe Hesabını Bağla',
    stripeConnecting: 'Bağlanıyor...',
    stripeNoEmail: 'Mağaza e-postası ayarlanmadı. Lütfen önce mağaza ayarlarından bir e-posta girin.',
    stripeConnectFailed: 'Stripe bağlantısı başarısız oldu. Lütfen tekrar deneyin.',
    stripeStatusTitle: 'Stripe Durumu',
    stripeNotConnected: 'Stripe hesabı bağlı değil',
    stripeActive: 'Aktif',
    stripeInactive: 'Pasif',
    stripeCanSell: 'Ürün satabilirsiniz',
    stripeCannotSell: 'Henüz ürün satamazsınız',
    stripeAccountId: 'Hesap ID',
    stripeContinueOnboarding: 'Onboarding Devam Et',
    stripeResetBtn: 'Stripe Sıfırla',
    stripeResetTitle: 'Stripe Hesabını Sıfırla',
    stripeResetDesc: 'Emin misiniz? Bu Stripe hesabınızı kaldırır ve yeniden bağlamanız gerekir.',
    stripeResetConfirm: 'Evet, Sıfırla',
    stripeResetting: 'Sıfırlanıyor...',
    stripeResetFailed: 'Stripe sıfırlama başarısız',
    stripeProductsBlockTitle: 'Ürün Eklemek için Stripe Bağlayın',
    stripeProductsBlockDesc: 'Mağazanız henüz Stripe ile bağlı değil. Lütfen önce ana panelden bağlantıyı tamamlayın.',
    stripeBlockTitle: 'Stripe Bağlantısı Gerekli',
    stripeBlockDesc: 'Ürün eklemek ve gelir elde etmek için önce Stripe hesabınızı bağlamanız gerekir.',
    fillRequired: 'Lütfen tüm zorunlu alanları doldurun',
    saveFailed: 'Ürün kaydedilemedi',
    deleteFailed: 'Ürün silinemedi',
    storeNameLabel: 'Mağaza Adı',
    storeDescLabel: 'Mağaza Açıklaması',
    ordersEmpty: 'Henüz sipariş yok',
    salesLabel: 'satış',
    stockLeft: 'kalan',
    lowStock: 'Az Stok',
    revenueLabel: 'Gelir',
    categoryLabel: 'Kategori',
    orderLabel: 'Sipariş',
    itemsLabel: 'ürün',
    guestCustomer: 'Misafir',
    noProductsYet: 'Henüz ürün yok',
    addProductDesc: 'Satışa başlamak için ilk ürününüzü ekleyin',
    productNameLabel: 'Ürün Adı',
    productNamePlaceholder: 'Ürün adını girin',
    otherCategory: 'Diğer',
    productDescPlaceholder: 'Ürün açıklamasını girin...',
    productImageLabel: 'Ürün Görseli',
    uploading: 'Yükleniyor...',
    uploadImage: 'Görsel Yükle',
    deleteProductTitle: 'Ürün Silinsin mi?',
    deleteProductDesc: 'Silmek istediğinizden emin misiniz',
    noProducts: 'Henüz ürün yok',
    uploadNetworkError: 'Sunucu üzerinden görsel yükleme mevcut değil. Lütfen görsel URLsi girin.',
    useImageUrl: 'Görsel Linki',
    hideUrl: 'Linki Kapat',
    imageUrlHint: 'Görsel yükleme çalışmazsa, doğrudan görsel bağlantısını girin:',
    imageUrlPlaceholder: '/uploads/example.jpg',
    applyUrl: 'Uygula',
  },
  notifications: {
    title: 'Bildirimler',
    unread: 'okunmamış',
    markAllRead: 'Tümünü okundu işaretle',
    allNotifications: 'Tümü',
    unreadNotifications: 'Okunmamış',
    noNotifications: 'Bildirim yok',
    noNotificationsDesc: 'Güncelsiniz! Daha sonra tekrar kontrol edin.',
    markRead: 'Okundu işaretle',
  },
  addresses: {
    title: 'Adreslerim',
    yourAddresses: 'Adresleriniz',
    saved: 'kayıtlı',
    location: 'konum',
    locations: 'konum',
    addNew: 'Yeni Ekle',
    noAddresses: 'Henüz Adres Yok',
    noAddressesDesc: 'İlk teslimat adresinizi ekleyin',
    addAddress: 'Adres Ekle',
    signIn: 'Lütfen Giriş Yapın',
    signInDesc: 'Adresleri yönetmek için giriş yapın',
    addNewAddress: 'Yeni Adres Ekle',
    editAddress: 'Adresi Düzenle',
    deleteAddress: 'Adres Silinsin mi?',
    deleteAddressDesc: 'Silmek istediğinizden emin misiniz',
    cannotBeUndone: 'Bu işlem geri alınamaz.',
    setDefault: 'Varsayılan Yap',
    backToProfile: 'Profile Dön',
    default: 'Varsayılan',
    searchTab: 'Ara',
    savedTab: 'Kayıtlı',
    resultsFound: 'sonuç',
    startTypingHint: 'Adresinizi yazmaya başlayın...',
    editPin: 'Pin Düzenle',
    locationType: 'Konum Türü',
    apartment: 'Apartman',
    house: 'Ev',
    office: 'Ofis',
    doorbellName: 'Zil İsmi',
    doorbellNamePlaceholder: 'örn. "Ali Veli"',
    entrance: 'Giriş',
    entrancePlaceholder: 'örn. "Giriş B"',
    additionalInfo: 'Kurye için ek bilgi',
    additionalInfoPlaceholder: 'Kurye için yönlendirme...',
    addressRequired: 'Lütfen bir adres seçin',
    phoneRequired: 'Telefon numarası gerekli',
  },
  payment: {
    title: 'Ödeme Yöntemleri',
    saved: 'kayıtlı',
    method: 'yöntem',
    methods: 'yöntem',
    addNew: 'Yeni Ekle',
    noPaymentMethods: 'Henüz Ödeme Yöntemi Yok',
    noPaymentMethodsDesc: 'İlk ödeme yönteminizi ekleyin',
    addPaymentMethod: 'Ödeme Yöntemi Ekle',
    savePaymentMethod: 'Ödeme Yöntemini Kaydet',
    addPaymentMethodTitle: 'Ödeme Yöntemi Ekle',
    setDefault: 'Varsayılan Yap',
    default: 'Varsayılan',
    deletePaymentMethod: 'Ödeme Yöntemi Silinsin mi?',
    deleteDesc: 'Bu ödeme yöntemini silmek istediğinizden emin misiniz?',
    backToProfile: 'Profile Dön',
    card: 'Kart',
    paypal: 'PayPal',
    bank: 'Banka',
    cardNumber: 'Kart Numarası',
    cardHolder: 'Kart Sahibi',
    expiryDate: 'Son Kullanma Tarihi',
    cvv: 'CVV',
    cardType: 'Kart Tipi',
    paypalEmail: 'PayPal E-posta',
    bankName: 'Banka Adı',
    accountNumber: 'Hesap Numarası',
    setAsDefault: 'Varsayılan ödeme yöntemi olarak ayarla',
    cardHolder_placeholder: 'Karttaki isim',
    editPaymentMethod: 'Ödeme Yöntemini Düzenle',
    saveChanges: 'Değişiklikleri Kaydet',
    expires: 'Son kullanma',
    cardHolderLabel: 'Kart Sahibi',
  },
  security: {
    title: 'Güvenlik Ayarları',
    manageDesc: 'Hesap güvenliğinizi yönetin',
    changePassword: 'Şifre Değiştir',
    changePasswordDesc: 'Hesap şifrenizi güncelleyin',
    twoFA: 'İki Faktörlü Doğrulama',
    biometric: 'Biyometrik Giriş',
    activeSessions: 'Aktif Oturumlar',
    loginHistory: 'Giriş Geçmişi',
    viewRecentActivity: 'Son etkinliği görüntüle',
    deleteAccount: 'Hesabı Sil',
    deleteDesc: 'Hesabı kalıcı olarak kaldır',
    recentLoginActivity: 'Son Giriş Etkinliği',
    enable2FA: '2FA Etkinleştir',
    disable2FA: '2FA Devre Dışı Bırak',
    sessions: 'aktif cihaz',
    enable2FATitle: 'İki Faktörlü Doğrulamayı Etkinleştir',
    disable2FATitle: 'İki Faktörlü Doğrulamayı Devre Dışı Bırak',
    enable2FADesc: '2FA ile hesabınıza ekstra bir güvenlik katmanı ekleyin.',
    disable2FADesc: '2FA koruması olmadan hesabınız daha az güvenli olacaktır.',
    activeSessionsTitle: 'Aktif Oturumlar',
    updatePassword: 'Şifreyi Güncelle',
    currentPassword: 'Mevcut Şifre',
    newPassword: 'Yeni Şifre',
    confirmPassword: 'Yeni Şifreyi Onayla',
    enterCurrentPassword: 'Mevcut şifreyi girin',
    enterNewPassword: 'Yeni şifreyi girin',
    confirmNewPassword: 'Yeni şifreyi onaylayın',
    passwordsDoNotMatch: 'Şifreler eşleşmiyor!',
    passwordMinLength: 'Şifre en az 8 karakter olmalıdır!',
    scanQRCode: 'QR Kodu Tara',
    useAuthenticator: 'Google Authenticator veya benzer bir uygulama kullanın',
    success: 'Başarılı',
    failed: 'Başarısız',
    backToProfile: 'Profile Dön',
    current: 'Mevcut',
    logout: 'Çıkış Yap',
    deleteAccountTitle: 'Hesabı Sil',
    deleteAccountDesc: 'Bu işlem geri alınamaz. Tüm verileriniz kalıcı olarak silinecektir.',
    deleteWarning: '• Tüm siparişler ve satın alma geçmişi silinecek\n• Kayıtlı adresler ve ödeme yöntemleri kaldırılacak\n• İstek listesi öğeleri kaybolacak\n• Bu işlem geri alınamaz',
  },
  help: {
    title: 'Yardım & Destek',
    subtitle: '7/24 buradayız',
    liveChat: 'Canlı Sohbet',
    liveChatDesc: 'Destek ekibimizle sohbet edin',
    available247: '7/24 Mevcut',
    emailSupport: 'E-posta Desteği',
    emailSupportDesc: 'support@bazarak.com',
    responseTime: '24 saat içinde yanıt',
    phoneSupport: 'Telefon Desteği',
    phoneSupportDesc: '+49 30 1234 5678',
    monFri: 'Pzt-Cum, 09:00-18:00',
    whatsapp: 'WhatsApp',
    whatsappDesc: 'WhatsApp\'tan mesaj gönderin',
    faq: 'Sık Sorulan Sorular',
    allTopics: 'Tüm Konular',
    orders: 'Siparişler',
    payments: 'Ödemeler',
    shipping: 'Kargo',
    returns: 'İadeler',
    account: 'Hesap',
    quickLinks: 'Hızlı Bağlantılar',
    terms: 'Hizmet Şartları',
    privacy: 'Gizlilik Politikası',
    refund: 'İade Politikası',
    shippingPolicy: 'Kargo Politikası',
    stillNeedHelp: 'Hâlâ yardıma mı ihtiyacınız var?',
    stillNeedHelpDesc: 'Aradığınızı bulamadınız mı? Destek ekibimiz yardıma hazır.',
    contactSupport: 'Destek ile İletişime Geç',
    contactSupportTitle: 'Destekle İletişime Geç',
    yourName: 'Adınız',
    emailAddress: 'E-posta Adresi',
    subject: 'Konu',
    message: 'Mesaj',
    sendMessage: 'Mesaj Gönder',
    noFaqFound: 'Bu kategoride SSS bulunamadı',
    startChat: 'Sohbeti Başlat',
    sendEmail: 'E-posta Gönder',
    callNow: 'Şimdi Ara',
    openWhatsApp: "WhatsApp'ı Aç",
    backToProfile: 'Profile Dön',
    subjectPlaceholder: 'Size nasıl yardımcı olabiliriz?',
    messagePlaceholder: 'Lütfen sorununuzu ayrıntılı açıklayın...',
    namePlaceholder: 'Adınızı girin',
  },
  footer: {
    quickLinks: 'Hızlı Bağlantılar',
    support: 'Destek',
    downloadApp: 'Uygulamayı İndir',
    description: 'Bazaarak, taze ve kaliteli ürünler için online mağaza. En iyi fiyat ve en hızlı teslimat garantisi.',
    rights: '© 2026 Bazaarak. Tüm hakları saklıdır.',
    contactUs: 'Bize Ulaşın',
    terms: 'Kullanım Koşulları',
    privacy: 'Gizlilik Politikası',
    helpCenter: 'Yardım Merkezi',
    appStore: 'App Store',
    googlePlay: 'Google Play',
  },
  language: {
    title: 'Dil',
    persian: 'Farsça',
    english: 'İngilizce',
    german: 'Almanca',
    turkish: 'Türkçe',
    arabic: 'Arapça',
    selectLanguage: 'Dil Seçin',
    currentLanguage: 'Mevcut Dil',
    availableLanguages: 'Mevcut Diller',
    changeInfo: 'Dil değiştirmek uygulamanın tüm arayüzünü hemen günceller.',
    switchConfirm: '{{name}} ({{native}}) diline geçilsin mi?',
  },
  datetime: {
    title: 'Teslimat Planla',
    quickSelect: 'Hızlı Seçim',
    selectDate: 'Tarih Seç',
    selectTime: 'Saat Seç',
    today: 'Bugün',
    tomorrow: 'Yarın',
    dayAfter: 'Yarından Sonra',
    nextWeek: 'Gelecek Hafta',
    su: 'Pz',
    mo: 'Pt',
    tu: 'Sa',
    we: 'Ça',
    th: 'Pe',
    fr: 'Cu',
    sa: 'Ct',
    deliveryTo: 'Teslimat adresi',
    pickupFrom: 'Mağazadan teslimat',
    courierArrives: 'Kurye bu zaman aralığında varacak',
    readyForPickup: 'Siparişiniz teslim almaya hazır olacak',
    confirmSchedule: 'Zamanlamayı Onayla',
    selectDateTime: 'Tarih ve saat seçin',
  },
  bazaarHub: {
    title: 'Bazaarak',
    subtitle: 'Her şey tek yerde',
    categories: 'Kategoriler',
    search: 'Ara',
    cart: 'Sepet',
    orders: 'Siparişler',
    profile: 'Profil',
    wishlist: 'Favoriler',
    offers: 'Teklifler',
    vendors: 'Satıcılar',
    addresses: 'Adresler',
    notifications: 'Bildirimler',
    settings: 'Ayarlar',
    help: 'Yardım',
  },
  theme: {
    darkMode: 'Karanlık Mod',
    lightMode: 'Aydınlık Mod',
  },
  search: {
    productLabel: 'Ürünler',
    categoryLabel: 'Kategoriler',
    wishlistLabel: 'Favoriler',
    offerLabel: 'Teklifler',
    addressLabel: 'Adresler',
    vendorLabel: 'Satıcılar',
    for: 'için',
    filteringBy: 'Filtreleme',
    clearCategoryFilter: 'Kategori filtresini temizle',
    relevance: 'Alaka',
    priceLowToHigh: 'Fiyat: Düşükten Yükseğe',
    priceHighToLow: 'Fiyat: Yüksekten Düşüğe',
    newest: 'En Yeni',
    topRated: 'En Yüksek Puanlı',
    allPrices: 'Tüm Fiyatlar',
    allRatings: 'Tüm Puanlar',
    sortBy: 'Sırala',
    priceRange: 'Fiyat Aralığı',
    rating: 'Puan',
    filters: 'Filtreler',
    applyFilters: 'Filtreleri Uygula',
    clearAllFilters: 'Tüm filtreleri temizle',
    brand: 'Marka',
    color: 'Renk',
    size: 'Beden',
    allBrands: 'Tüm Markalar',
    allColors: 'Tüm Renkler',
    allSizes: 'Tüm Bedenler',
    noBrands: 'Marka bulunamadı',
    noColors: 'Renk bulunamadı',
    noSizes: 'Beden bulunamadı',
    typeToFind: 'Ürün, kategori ve daha fazlasını bulmak için yazın',
    resultsFor: 'Arama sonuçları:',
    resultsFound: 'sonuç bulundu',
    items: 'Ürünler',
    stores: 'Mağazalar',
    categories: 'Kategoriler',
    itemFound: 'ürün',
    storeFound: 'mağaza',
    categoryFound: 'kategori',
    tryDifferentKeywords: 'Farklı anahtar kelimeler deneyin',
    noProductsFound: 'Ürün bulunamadı',
    noStoresFound: 'Mağaza bulunamadı',
    noCategoriesFound: 'Kategori bulunamadı',
  },
  aiAssistant: {
    title: 'Yapay Zeka Asistanı',
    subtitle: 'Size nasıl yardımcı olabilirim?',
    hotDeals: 'Sıcak Fırsatlar',
    trackOrder: 'Sipariş Takibi',
    popular: 'Popüler',
    findStores: 'Mağaza Bul',
    comingSoon: 'Akıllı yapay zeka özellikleri yakında!',
    askAnything: 'Her şeyi sor...',
    errorReply: 'Üzgünüm, bir şeyler yanlış gitti. Lütfen tekrar deneyin.',
  },
  stores: {
    title: 'Tüm Mağazalar',
    stores: 'mağaza',
    searchPlaceholder: 'Mağaza ara: isim, şehir veya etiket...',
    sortPopular: 'Popüler',
    sortRating: 'En Yüksek Puanlı',
    sortNewest: 'En Yeni',
    sortProducts: 'En Çok Ürün',
    endOfList: 'Liste sonu',
  },
  errors: {
    loadFailed: 'Veriler yüklenemedi. Lütfen tekrar deneyin.',
    noResults: 'Sonuç bulunamadı',
  },
  admin: {
    title: 'Yönetici Paneli',
    menu: 'Menü',
    backToSite: 'Siteye Dön',
    dashboard: 'Kontrol Paneli',
    users: 'Kullanıcılar',
    stores: 'Mağazalar',
    products: 'Ürünler',
    orders: 'Siparişler',
    categories: 'Kategoriler',
    search: 'Bu bölümde ara...',
    totalUsers: 'Toplam Kullanıcı',
    totalStores: 'Toplam Mağaza',
    totalProducts: 'Toplam Ürün',
    totalOrders: 'Toplam Sipariş',
    totalRevenue: 'Toplam Gelir',
    pendingOrders: 'Bekleyen Siparişler',
    quickActions: 'Hızlı İşlemler',
    addCategory: 'Kategori Ekle',
    addProduct: 'Ürün Ekle',
    viewOrders: 'Siparişleri Gör',
    manageUsers: 'Kullanıcıları Yönet',
    name: 'İsim',
    email: 'E-posta',
    role: 'Rol',
    joined: 'Katılma Tarihi',
    storeName: 'Mağaza Adı',
    address: 'Adres',
    rating: 'Puan',
    products: 'Ürünler',
    productName: 'Ürün Adı',
    price: 'Fiyat',
    stock: 'Stok',
    status: 'Durum',
    orderId: 'Sipariş ID',
    customer: 'Müşteri',
    total: 'Toplam',
    date: 'Tarih',
    categoryName: 'Kategori Adı',
    parentCategory: 'Üst Kategori',
    mainCategory: 'Ana Kategori',
    noneTopLevel: 'Yok (Üst Seviye)',
    sortOrder: 'Sıralama',
    confirmDelete: 'Silmeyi Onayla',
    confirmDeleteDesc: 'Bu öğeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    edit: 'Düzenle',
    canAddProducts: 'Ürün Ekleme İzni',
  },
};